import _str from "shared/util/_str";
import _ from "underscore";

const C = {
	CSS_PREFIX: "OkModal",
	DEFAULT_CONFIG: {
		ctaLink: "#",
		ctaText: _str("Learn more"),
		onAction: _.noop,
		onClose: _.noop,
		windowshade: true,
		noscroll: true,
		noclose: false,
	},
	FADE_IN_TIME: 300,
	FADE_OUT_TIME: 150,
};

export default C;



// WEBPACK FOOTER //
// ./src/reflux/okmodal/util/Constants.js